(() => {
  const focusMessages = (root = document) => {
    root.querySelectorAll('[data-lg-form-message]').forEach((message) => {
      if (message.dataset.lgMessageFocused === 'true') return
      message.dataset.lgMessageFocused = 'true'
      message.focus({ preventScroll: true })
      message.scrollIntoView({ block: 'center', behavior: 'auto' })
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => focusMessages(), { once: true })
  } else {
    focusMessages()
  }

  document.addEventListener('shopify:section:load', (event) => focusMessages(event.target))
})()
